module.exports = __webpack_public_path__ + "img/blinds-raised.2c2ef746.svg";